
import Vue from "vue";

export default Vue.extend({
  name: "dashboard",
  components: {
    WidgetWelcome: () => import("@/views/admin/dashboard/WidgetWelcome.vue")
  }
});
